export interface ComiteItem {
  id: string;
  nom: string;
  description: string;
  frequence: string;
  owner: string;
  objectifs: string[];
  niveau: 'Stratégique' | 'Opérationnel' | 'Culture';
  couleurGradient: string;
  icone: 'Gavel' | 'Users' | 'ShieldCheck' | 'FileText' | 'Sparkles' | 'HeartHandshake' | 'AlertTriangle' | 'Server' | 'Leaf' | 'Layers' | 'ShieldHalf';
  imageUrl: string;
}

export const comitesBZ: ComiteItem[] = [
  {
    id: 'ca',
    nom: 'CA',
    description: "Conseil d'administration BZ : alignement stratégique, gouvernance, risques et ESG.",
    frequence: 'Trimestriel',
    owner: 'Présidence (Dany Bourassa)',
    objectifs: [
      'Valider la stratégie et les budgets',
      'Suivre les risques majeurs et la conformité',
      'Superviser ESG et réputation'
    ],
    niveau: 'Stratégique',
    couleurGradient: 'from-amber-500 to-orange-600',
    icone: 'Gavel',
    imageUrl: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&auto=format&fit=crop&q=80'
  },
  {
    id: 'ce',
    nom: 'Dany CA/CE',
    description: "Dany CA/CE : décisions d'affaires rapides, suivi des objectifs trimestriels et arbitrages.",
    frequence: 'Mensuel',
    owner: 'Président & DG (Dany Bourassa)',
    objectifs: [
      'Piloter OKR/initiatives clés',
      'Arbitrer les priorités et budgets',
      'Suivre la performance financière'
    ],
    niveau: 'Stratégique',
    couleurGradient: 'from-indigo-500 to-blue-600',
    icone: 'Users',
    imageUrl: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=800&auto=format&fit=crop&q=80'
  },
  {
    id: 'prisme',
    nom: 'Comité PRIsME',
    description: 'Garde rapprochée PRIsME : gouvernance produit, communication interne, excellence opérationnelle et déploiement stratégique.',
    frequence: 'Selon besoins',
    owner: 'Fondateur PRIsME (Dany Bourassa)',
    objectifs: [
      'Gouvernance et évolution du produit PRIsME',
      'Communication officielle aux Primes et équipes',
      'Excellence opérationnelle et qualité des livrables'
    ],
    niveau: 'Stratégique',
    couleurGradient: 'from-violet-500 to-purple-600',
    icone: 'Sparkles',
    imageUrl: 'https://images.unsplash.com/photo-1551288049-bebda4e38f72?w=800&auto=format&fit=crop&q=80'
  },
  {
    id: 'securite',
    nom: 'Sécurité',
    description: 'Posture cyber, risques, incidents, conformité (NIST 2.0, clients, audit).',
    frequence: 'Mensuel',
    owner: 'VP Technologie et Sécurité (François Delisle)',
    objectifs: [
      'Suivre risques et incidents',
      'Prioriser remédiations et audits',
      'Aligner sécurité aux projets'
    ],
    niveau: 'Opérationnel',
    couleurGradient: 'from-emerald-500 to-teal-600',
    icone: 'ShieldCheck',
    imageUrl: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800&auto=format&fit=crop&q=80'
  },
  {
    id: 'rh-loi-27',
    nom: 'RH • Loi 27',
    description: 'Comité RH & conformité travail/données (Loi 27, équité, privacy interne).',
    frequence: 'Bimestriel',
    owner: 'CA/CE (Dany Bourassa)',
    objectifs: [
      'Veille et conformité Loi 27',
      'Politiques RH, équité, gestion des données',
      'Formation et communication employés'
    ],
    niveau: 'Opérationnel',
    couleurGradient: 'from-rose-500 to-pink-600',
    icone: 'FileText',
    imageUrl: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=800&auto=format&fit=crop&q=80'
  },
  {
    id: 'comite-sante-securite',
    nom: 'Comité santé et sécurité',
    description: 'Comité SST actif BZ : mandat, membres, rencontres, procès-verbaux, plan de prévention 2026-2027 et FAS.',
    frequence: 'Selon calendrier SST',
    owner: 'Louis-Alexandre Hébert',
    objectifs: [
      'Structurer le comité SST actif',
      'Suivre le plan de prévention 2026-2027',
      'Conserver les PV, FAS et preuves annuelles'
    ],
    niveau: 'Opérationnel',
    couleurGradient: 'from-sky-600 to-emerald-600',
    icone: 'ShieldHalf',
    imageUrl: 'https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?w=800&auto=format&fit=crop&q=80'
  },
  {
    id: 'profitabilite-clients',
    nom: 'Comité profitabilité clients',
    description: 'Analyse de la rentabilité client : marge, effort, satisfaction, risque, comptes difficiles et décisions commerciales.',
    frequence: 'Mensuel',
    owner: 'Direction / Finance / Ventes',
    objectifs: [
      'Identifier les clients à forte valeur et les comptes à corriger',
      'Relier marge, effort opérationnel, satisfaction et risque',
      'Décider des ajustements de prix, service, périmètre ou accompagnement'
    ],
    niveau: 'Stratégique',
    couleurGradient: 'from-emerald-500 to-green-700',
    icone: 'Layers',
    imageUrl: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&auto=format&fit=crop&q=80'
  },
  {
    id: 'ia-agentique',
    nom: 'Comité IA agentique',
    description: 'Gouvernance des agents IA : priorités, valeur réelle, adoption humaine, sécurité, RAG, logs et standards d’usage.',
    frequence: 'Mensuel',
    owner: 'Dany Bourassa / Éric Durand',
    objectifs: [
      'Prioriser les cas d’usage IA et les agents à industrialiser',
      'Mesurer la valeur, l’adoption et les risques opérationnels',
      'Encadrer sécurité, données, prompts, RAG, logs et responsabilités'
    ],
    niveau: 'Stratégique',
    couleurGradient: 'from-cyan-500 to-blue-700',
    icone: 'Sparkles',
    imageUrl: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&auto=format&fit=crop&q=80'
  },
  {
    id: 'directeurs',
    nom: 'Comité des directeurs',
    description: 'Rituel mensuel de direction : divulgation des chiffres, évolution de chaque département, blocages, décisions et priorités.',
    frequence: 'Mensuel',
    owner: 'Présidence / Directeurs BZ',
    objectifs: [
      'Partager les chiffres et les signaux de gestion',
      'Faire le point sur l’évolution de chaque département',
      'Documenter les décisions, responsables, échéances et suivis'
    ],
    niveau: 'Stratégique',
    couleurGradient: 'from-slate-700 to-indigo-700',
    icone: 'Users',
    imageUrl: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?w=800&auto=format&fit=crop&q=80'
  },
  {
    id: 'social',
    nom: 'Comité social',
    description: 'Culture BZ, engagement, événements internes et bien-être.',
    frequence: 'Mensuel',
    owner: 'Culture BZ / Ambassadeurs',
    objectifs: [
      'Engagement et rétention',
      'Onboarding et intégration',
      'Événements, reconnaissance, philanthropie'
    ],
    niveau: 'Culture',
    couleurGradient: 'from-purple-500 to-fuchsia-600',
    icone: 'HeartHandshake',
    imageUrl: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&auto=format&fit=crop&q=80'
  }
];

export const comitesSuggeresQC: ComiteItem[] = [
  {
    id: 'ia-innovation',
    nom: 'IA / Innovation produit',
    description: "Valorisation des données, cas d'usage IA, R&D, expérimentation encadrée.",
    frequence: 'Mensuel',
    owner: 'VP Tech / Produit',
    objectifs: [
      "Pipeline d'idées IA/produit",
      'Garde-fous éthiques et sécuritaires',
      'Feuille de route innovation'
    ],
    niveau: 'Stratégique',
    couleurGradient: 'from-cyan-500 to-sky-600',
    icone: 'Sparkles',
    imageUrl: 'https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=800&auto=format&fit=crop&q=80'
  },
  {
    id: 'continuite',
    nom: 'Continuité / Crise',
    description: 'Plan de continuité, reprises après sinistre, crises clients et communication.',
    frequence: 'Trimestriel',
    owner: 'Ops & Sécurité',
    objectifs: [
      'Tester PCA/DRP',
      'Coordonner la réponse aux incidents majeurs',
      'Maintenir la chaîne de communication'
    ],
    niveau: 'Opérationnel',
    couleurGradient: 'from-slate-500 to-slate-700',
    icone: 'AlertTriangle',
    imageUrl: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&auto=format&fit=crop&q=80'
  },
  {
    id: 'architecture',
    nom: 'Architecture & Plateforme',
    description: 'Décisions techno, dette technique, standards, performance et coûts cloud.',
    frequence: 'Mensuel',
    owner: 'Direction technique',
    objectifs: [
      'Valider les choix techno',
      'Réduire la dette et sécuriser',
      'Optimiser coûts et performance'
    ],
    niveau: 'Opérationnel',
    couleurGradient: 'from-blue-500 to-indigo-700',
    icone: 'Layers',
    imageUrl: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&auto=format&fit=crop&q=80'
  },
  {
    id: 'donnees-privacy',
    nom: 'Données / Privacy (Loi 25)',
    description: 'Gouvernance données, conformité Loi 25/PCI, catalogage et rétention.',
    frequence: 'Bimestriel',
    owner: 'DPO / Sécurité',
    objectifs: [
      "Tenir l'inventaire des données",
      'Gérer DPIA et requêtes personnes concernées',
      'Former les équipes à la privacy'
    ],
    niveau: 'Opérationnel',
    couleurGradient: 'from-amber-500 to-yellow-600',
    icone: 'ShieldHalf',
    imageUrl: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&auto=format&fit=crop&q=80'
  },
  {
    id: 'esg',
    nom: 'ESG / Développement durable',
    description: "Environnement, social, gouvernance et rapports d'impact.",
    frequence: 'Trimestriel',
    owner: 'CA / ESG lead',
    objectifs: [
      'Suivre indicateurs ESG',
      'Programmes carbone et inclusion',
      'Rapports clients et parties prenantes'
    ],
    niveau: 'Stratégique',
    couleurGradient: 'from-green-500 to-lime-600',
    icone: 'Leaf',
    imageUrl: 'https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=800&auto=format&fit=crop&q=80'
  },
  {
    id: 'qualite',
    nom: 'Qualité / Amélioration continue',
    description: 'Standards delivery, audits internes, leçons apprises, Lean/Agile.',
    frequence: 'Mensuel',
    owner: 'Opérations / Delivery',
    objectifs: [
      'Auditer et améliorer les processus',
      'Suivre les indicateurs qualité',
      'Industrialiser les leçons apprises'
    ],
    niveau: 'Opérationnel',
    couleurGradient: 'from-violet-500 to-purple-700',
    icone: 'Server',
    imageUrl: 'https://images.unsplash.com/photo-1551288049-bebda4e38f72?w=800&auto=format&fit=crop&q=80'
  }
];
